import { Navigate, useLocation } from "react-router-dom";
import { HOME_ROUTE, LOGIN_ROUTE } from "../routes/web/rootRoutes";
import authManager from "../utils/authManager";
import toast from "react-hot-toast";

const UserAuth = ({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname + location.search;

  const hasToken = authManager.hasAccessToken();
  const role = authManager.getRole();

  console.log(hasToken,role);
  

  if (hasToken && role === "User") {
    return children;
  } else if (hasToken && role === "Partner") {
    toast.error("You are a partner. You can't create orders.");
    return <Navigate to={HOME_ROUTE} replace />;
  } else {
    return (
      <Navigate
        to={`${LOGIN_ROUTE}?refer=${encodeURIComponent(currentPath)}`}
        replace
      />
    );
  }
};

export default UserAuth;
